import { render, staticRenderFns } from "./Tab_tools.vue?vue&type=template&id=a0baa8b4"
import script from "./Tab_tools.vue?vue&type=script&lang=js"
export * from "./Tab_tools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports